const modeUrlObj = {
    // 生产环境
    'production': {
        // baseUrl: 'https://116.62.96.253:8199'
        // baseUrl: 'https://piyao-api.test.thecover.cn'
        baseUrl: 'https://jb-api.scjb.gov.cn'
    },

    // 开发环境
    'development': {
        // baseUrl: 'http://mock.studyinghome.com/mock/5f72d61717a34e389b5d6863'
        // baseUrl: 'https://116.62.96.253:8199'
        // baseUrl: 'https://piyao-api.test.thecover.cn'
        baseUrl: 'https://jb-cms.fm-dev.thecover.cn'
    }
}

export default modeUrlObj[process.env.NODE_ENV]